// Actions constants
export const E = 'EDITABLE';
export const C = 'CLICKABLE';
export const V = 'VIEWABLE';
export const D = 'DELETABLE';
export const S = 'SELECTABLE';
